"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Card = _interopRequireDefault(require("./Card"));

var _Container = _interopRequireDefault(require("./Container"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  border-radius: ", ";\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.0625);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Sheet = (0, _styledComponents["default"])(_Card["default"].withComponent(_Container["default"]))(_templateObject(), _theme["default"].radii[2]);
Sheet.displayName = 'Sheet';
Sheet.defaultProps = {
  theme: _theme["default"],
  bg: 'rgba(255, 255, 255, 0.875)',
  p: [3, 4]
};
var _default = Sheet;
exports["default"] = _default;